import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled(Layout)`
  background-color: transparent;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: row;

  ${({ theme }) => theme.mediaQueries.TABLET} {
    flex-direction: column;
  }
`;
